@if (aiChatAddContext$ | async) {
  <ds-chat-input
    #chatInput
    [contextChips]="(contextChips$ | async) ?? []"
    [isLoading]="status !== AiChatStatus.IDLE"
    [placeholder]="'ai_chat_input_placeholder' | translate"
    [label]="'ai_chat_input_label' | translate"
    [contextFiltersAriaLabel]="'ai_chat_context_chips_label' | translate"
    [addContextAriaLabel]="'ai_chat_restore_context' | translate"
    [sendMessageAriaLabel]="'action_send' | translate"
    (messageSend)="onSendMessage($event)"
    (addContext)="onRestoreContext()"
    (contextChipDismissed)="onDismissChip()"
    (input)="onChatInputNativeInput($event)"
  ></ds-chat-input>
  <div class="disclaimer">
    {{ 'ai_chat_disclaimer' | translate }}
  </div>
} @else {
  <form
    class="chat-form d-flex flex-column mt-auto mt-auto"
    [formGroup]="form"
    (ngSubmit)="onSendMessageOld()"
    [attr.aria-invalid]="inputContext.validateOnSubmitOnly ? false : form.invalid"
  >
    <label class="chat-input-label" [for]="inputContext.id">
      {{ inputContext.label | translate }}
    </label>

    <div class="chat-input-row mb-2">
      <app-common-input
        class="chat-input"
        (keydown.enter)="onHandleEnterOld($event)"
        [form]="form"
        [formValidationRequest$]="formValidationRequest$"
        [context]="inputContext"
      >
      </app-common-input>

      <button
        ds-button
        class="send-button"
        type="submit"
        [disabled]="status !== AiChatStatus.IDLE"
        [variant]="DsButtonVariants.primary"
        [icon]="Icons.Send"
        [isIconOnly]="true"
        [attr.aria-label]="'action_send' | translate"
        data-test-id="send-message-button"
      ></button>
    </div>
    <div class="disclaimer">
      {{ 'ai_chat_disclaimer' | translate }}
    </div>
  </form>
}
